import { FileText } from 'lucide-react';

type Props = {
  material: string | null;
  fileKey: string | null;
};

export function InstructorMaterialViewer({ material, fileKey }: Props) {
  if (!material && !fileKey) return null;
  return (
    <div className="rounded-md border border-primary/30 bg-card p-3">
      <h3 className="text-sm font-semibold text-primary">Material del instructor</h3>
      {material && (
        <div className="mt-2 whitespace-pre-wrap text-sm text-card-foreground">{material}</div>
      )}
      {fileKey && (
        <p className="mt-2 flex items-center gap-1 text-xs text-muted-foreground">
          <FileText className="h-3 w-3" />
          Archivo adjunto: <span className="font-mono">{fileKey.split('/').pop()}</span>
        </p>
      )}
    </div>
  );
}
